module.exports = __webpack_public_path__ + "static/media/mission-start-card-background.270f3fd2.png";